import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationsService } from 'angular2-notifications';
import * as moment from 'moment';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { UserService } from '../services/user.service';
import { ClientOrderService } from '../clientorderreport/clientorderreport.service';

const defaults = {
    notif: {
        timeOut: 3000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: true,
        maxLength: 50
    }
}
@Component({
    selector: 'app-addexchangetrade',
    templateUrl: './addexchangetrade.component.html',
    styleUrls: ['./addexchangetrade.component.css']
})
export class AddExchangeTrade {
    element: any = {};
    public selectedDate: any = new Date();
    myForm: any = FormControl;
    Pair: string = "";
    liqpairs: any = [];
    public pairListSearchCopy: any = []
    exchangeList = [];
    max: Date = new Date();
    today = new Date();
    feeValue: any;
    constructor(
        public dialogRef: MatDialogRef<AddExchangeTrade>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private notifSer: NotificationsService,
        public fb: FormBuilder,
        public userService: UserService,
        public clientService: ClientOrderService
    ) {
        this.getExchangeList();
        this.getInternalPairList();
        this.element = data;
        this.element['OrderType'] = 'MANUAL';
        this.myForm = this.fb.group({
            Exchange: ['', [Validators.required]],
            Pair: ['', [Validators.required]],
            TradeDate: ['', [Validators.required]],
            Side: ['', [Validators.required]],
            Quantity: ['', [Validators.required, Validators.min(0.00001)]],
            TradePrice: ['', [Validators.required, Validators.min(0.00001)]],
            OrderType: [''],
            OrderId: [''],
            TradeId: [''],
            ClientOrderId: [''],
            Fee: ['', [Validators.min(0)]],
            FeeCurrency: [''],
            CommentText: [''],
        });
        if (this.myForm.controls["TradeDate"]) {
            this.myForm.controls["TradeDate"].setValidators([Validators.required]);
            this.myForm.controls["TradeDate"].updateValueAndValidity();
        } else {
            this.myForm.controls["TradeDate"].clearValidators();
            this.myForm.controls["TradeDate"].updateValueAndValidity();
        }
        this.myForm.get('Fee').valueChanges
            .subscribe(value => {
                this.feeValue = value;
                if (value > 0) {
                    this.myForm.controls["FeeCurrency"].setValidators([Validators.required]);
                    this.myForm.controls["FeeCurrency"].updateValueAndValidity();
                }
                else {
                    this.myForm.controls["FeeCurrency"].clearValidators();
                    this.myForm.controls["FeeCurrency"].updateValueAndValidity();
                }
            });
    }
    // Get pairs
    getInternalPairList() {
        this.userService.getInternalPair().subscribe(response => {
            response = response.map(function (item) {
                return { pair: `${item.BaseCCY}${item.QuoteCCY}` };
            })
            this.liqpairs = response.map(item => item.pair)
                .filter((value, index, self) => self.indexOf(value) === index).sort((a, b) => a > b ? 1 : -1);
            this.pairListSearchCopy = this.liqpairs
        })
    }
    pairsearch_manualtrade(): void {
        let term = this.Pair;
        this.liqpairs = this.pairListSearchCopy.filter(function (tag) {
            if (tag.toLowerCase().indexOf(term.toLowerCase()) >= 0 || tag.toLowerCase().indexOf(term.toLowerCase()) >= 0) {
                return tag;
            }
        });
        this.element['Pair'] = this.liqpairs[0];
    }
    //  Get exchanges
    getExchangeList() {
        this.userService.getExchanges().subscribe(response => {
            let data = response.map(function (item) {
                return { exchange: item.ExchangeName };
            })
            this.exchangeList = data.filter(name => name.exchange != 'BEST');
        })
    }

    // Save Form to database
    saveManualExchange() {
        const { notif } = defaults
        if (this.element) {
            this.element['TradeDate'] = moment(this.selectedDate).format('YYYY-MM-DD HH:mm:ss');
            this.element['TradeTS'] = moment(this.selectedDate).valueOf();
            if (!this.element['TradeDate']) {
                return this.notifSer.error('Error', 'Please fill the Trade Date', notif);
            }
            if (!this.element['Side']) {
                return this.notifSer.error('Error', 'Please fill the Side', notif);
            }
            if (!this.element['Exchange']) {
                return this.notifSer.error('Error', 'Please fill the Exchange', notif);
            }
            if (!this.element['Pair']) {
                return this.notifSer.error('Error', 'Please fill the Pair', notif);
            }
            if (!this.element['Quantity']) {
                return this.notifSer.error('Error', 'Please fill the Trade Quantity', notif);
            }
            if (!this.element['TradePrice']) {
                return this.notifSer.error('Error', 'Please fill the Trade Price', notif);
            }
            if (this.feeValue > 0 && !this.element['FeeCurrency']) {
                return this.notifSer.error('Error', 'Please fill the Fee Currency', notif);
            }
            if (this.feeValue < 0) return this.notifSer.error('Error', 'Fee Value cannot be negative', notif);
            this.userService.csrf().subscribe(success => {
                this.element['_csrf'] = success['_csrf']
                this.clientService.saveManualExchangeTrade(this.element).subscribe(data => {

                    if (data) {
                        this.notifSer.success('Success', data.message, notif)
                        // Emit the form data when closing the dialog
                        this.dialogRef.close({ success: true, data: data });
                    } else this.notifSer.error('Error', data.message, notif);
                })
            })

        }
    }
   
}


// WEBPACK FOOTER //
// ./src/app/addexchangetrade/addexchangetrade.component.ts